export default {
  data() {
    return {
      intelligentDistributionConfig: {
        model: 'manual',
        offers_per_consumer: 1,
        product_send_limits: [],
      },
    }
  },
  computed: {
    isIntelligentDistributionEnabled() {
      return (
        this.intelligentDistributionConfig.model === 'intelligent' ||
        (this.campaign && this.campaign.auto_distributed) ||
        (this.campanha && this.campanha.auto_distributed)
      )
    },
    offersPerConsumer() {
      const models = (this.campaign && this.campaign.user_distribution_models) || (this.campanha && this.campanha.user_distribution_models) || []

      const total = models.reduce((sum, model) => sum + (model.quantity || 0), 0)

      return total || this.intelligentDistributionConfig.offers_per_consumer
    },
  },
  watch: {
    'campaign.auto_distributed': {
      handler(newAutoDistributed) {
        if (newAutoDistributed !== undefined) {
          this.intelligentDistributionConfig.model = newAutoDistributed ? 'intelligent' : 'manual'
        }
      },
      immediate: true,
    },
    'campaign.user_distribution_models': {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          const total = newValue.reduce((sum, model) => sum + (model.quantity || 0), 0)
          if (this.intelligentDistributionConfig.offers_per_consumer !== total) {
            this.intelligentDistributionConfig.offers_per_consumer = total
          }
        }
      },
      immediate: true,
      deep: true,
    },
    'campanha.auto_distributed': {
      handler(newAutoDistributed) {
        if (newAutoDistributed !== undefined) {
          this.intelligentDistributionConfig.model = newAutoDistributed ? 'intelligent' : 'manual'
        }
      },
      immediate: true,
    },
    'campanha.user_distribution_models': {
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          const total = newValue.reduce((sum, model) => sum + (model.quantity || 0), 0)
          if (this.intelligentDistributionConfig.offers_per_consumer !== total) {
            this.intelligentDistributionConfig.offers_per_consumer = total
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initializeIntelligentDistribution(campaign) {
      if (campaign.maria_campaign_config) {
        this.intelligentDistributionConfig = {
          model: campaign.maria_campaign_config.enabled ? 'intelligent' : 'manual',
          offers_per_consumer: campaign.maria_campaign_config.offers_per_consumer || 5,
          product_send_limits: campaign.maria_campaign_config.product_send_limits || [],
        }
      }
    },
    updateDistributionModel(model) {
      this.intelligentDistributionConfig.model = model
    },
    getDistributionModelForAPI() {
      if (this.isIntelligentDistributionEnabled) {
        const models = (this.campaign && this.campaign.user_distribution_models) || (this.campanha && this.campanha.user_distribution_models) || []

        return models.length > 0 ? models : null
      }
      return null
    },
  },
}
